const carouselItems = [
  {
    title: '娱乐圈大瓜合集：2024年度十大惊天爆料回顾',
    desc: '盘点本年度最具话题度的娱乐圈黑料事件，从顶流塌房到私密视频流出，每一件都曾引爆全网。黑料网下载为您整理完整时间线和关键证据。',
    tag: '年度盘点',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20entertainment%20scene%20with%20warm%20crimson%20and%20golden%20spotlights%2C%20cinematic%20composition%2C%20mysterious%20atmosphere%2C%20editorial%20quality%2C%20dark%20elegant%20background%2C%20modern%20art%20style%2C%20high%20contrast%20warm%20tones&width=1200&height=600&seq=carousel-img-01&orientation=landscape',
    hot: true,
  },
  {
    title: '网红圈连环爆料：从直播间到真实面目的崩塌之路',
    desc: '多位知名网红接连被曝出私下真实面目，从虚假人设到商业欺诈，黑料在线观看为您揭开网红经济背后的真相。',
    tag: '深度报道',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20studio%20scene%20with%20dramatic%20amber%20and%20red%20lighting%2C%20mysterious%20silhouette%2C%20cinematic%20atmosphere%2C%20modern%20editorial%20style%2C%20warm%20dark%20gradients%2C%20professional%20composition&width=1200&height=600&seq=carousel-img-02&orientation=landscape',
    hot: true,
  },
  {
    title: '社会热点追踪：近期轰动全网的五大事件全记录',
    desc: '从企业高管丑闻到公共事件内幕，黑料视频在线播放独家整理近期最具影响力的社会热点事件，带你了解事件全貌。',
    tag: '社会观察',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20urban%20scene%20with%20dramatic%20warm%20crimson%20and%20deep%20amber%20tones%2C%20mysterious%20cityscape%2C%20cinematic%20lighting%2C%20editorial%20quality%2C%20modern%20art%20style%2C%20dark%20atmosphere%2C%20clean%20composition&width=1200&height=600&seq=carousel-img-03&orientation=landscape',
    hot: false,
  },
  {
    title: '综艺节目黑幕揭秘：那些被剪掉的精彩片段',
    desc: '多位知情人士向黑料网在线播放提供内部资料，揭露多档热门综艺节目中不为人知的幕后操作和被删减内容。',
    tag: '独家揭秘',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20backstage%20scene%20with%20dramatic%20spotlight%20and%20warm%20red%20tones%2C%20cinematic%20composition%2C%20mysterious%20atmosphere%2C%20editorial%20quality%2C%20dark%20elegant%20background%2C%20modern%20art%20style&width=1200&height=600&seq=carousel-img-04&orientation=landscape',
    hot: false,
  },
  {
    title: '商界风云：知名企业高管接连出事背后的秘密',
    desc: '近期多家知名企业高管陷入各种风波，黑料网在线观看深度梳理事件脉络，分析背后可能存在的利益关联和行业潜规则。',
    tag: '财经八卦',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20scene%20with%20dramatic%20amber%20and%20crimson%20lighting%2C%20silhouette%20figures%2C%20cinematic%20atmosphere%2C%20editorial%20quality%2C%20modern%20art%20style%2C%20dark%20warm%20gradients%2C%20professional%20composition&width=1200&height=600&seq=carousel-img-05&orientation=landscape',
    hot: true,
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-focus-3-line"></i>
            专题聚焦
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            黑料网下载精选专题内容，深入挖掘热门事件
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.slice(0, 1).map((item, i) => (
            <div
              key={i}
              className="lg:col-span-2 group relative rounded-2xl overflow-hidden bg-secondary-100 cursor-pointer"
            >
              <div className="relative aspect-[21/9] md:aspect-[21/8]">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-3">
                    {item.tag}
                  </span>
                  <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-background-50 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base text-background-50/80 max-w-2xl line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}

          {carouselItems.slice(1).map((item, i) => (
            <div
              key={i + 1}
              className="group relative rounded-xl overflow-hidden bg-secondary-100 cursor-pointer"
            >
              <div className="relative aspect-[16/9]">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
                {item.hot && (
                  <div className="absolute top-3 left-3">
                    <span className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                      <i className="ri-fire-fill text-xs"></i>
                      热门
                    </span>
                  </div>
                )}
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="inline-flex items-center px-2 py-0.5 rounded bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium mb-2">
                    {item.tag}
                  </span>
                  <h3 className="text-base md:text-lg font-heading font-bold text-background-50 line-clamp-2">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}